<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('vonestis_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('vonestis_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="subDetail" v-html="$t('vonestis_desc')"></div>
          <div class="subDetail" v-html="$t('vonestis_desc2')"></div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('vonestis_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('vonestis_table_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('vonestis_table_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('vonestis_table_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('vonestis_table_tr2_td1') }}</td>
                <td>{{ $t('vonestis_table_tr2_td2') }}</td>
                <td>{{ $t('vonestis_table_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('vonestis_table_tr3_td1') }}</td>
                <td>{{ $t('vonestis_table_tr3_td2') }}</td>
                <td>{{ $t('vonestis_table_tr3_td3') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('vonestis_reserve_title') }}</div>
          <ol>
            <li>{{ $injectEmails($t('vonestis_reserve_desc1')) }}</li>
            <li>{{ $t('vonestis_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'VonestisSpa',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/vonestis_spa_01.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_spa_02.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_spa_03.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_spa_04.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "vonestis_title": "본에스티스 스파",
    "vonestis_subtitle": "즐거운 여행지에서 일상을 잠시 잊게 하는 오감의 충만함",
    "prev_button": "이전",
    "vonestis_desc": "본에스티스 뷰티앤스파는 단순한 스킨케어를 넘어 일상의 지친 신체와 정신의 궁극적 균형 회복을 도모하는 보다 근본적인 스킨테라피를 지향합니다.",
    "vonestis_desc2": "</br>30여 년, 약 28만 시간, 12만 명의 피부를 직접 터치하여 결을 읽고, 맥을 찾으며 쌓아온 고귀한 무형의 가치를 편안한 휴식처럼 누리세요. 커플스위트룸, 커플룸, 개인룸으로 구성된 100여 평의 유니크한 스파 공간이 즐거운 여행지에서 일상을 잠시 잊게 하는 오감의 충만함을 당신에게 선사합니다.",
    "vonestis_program_title": "운영 프로그램",
    "vonestis_table_tr1_td1": "프로그램",
    "vonestis_table_tr1_td2": "옵션",
    "vonestis_table_tr1_td3": "요금(2인 기준)",
    "vonestis_table_tr2_td1": "피스풀 플래닛",
    "vonestis_table_tr2_td2": "60분",
    "vonestis_table_tr2_td3": "500,000 ~",
    "vonestis_table_tr3_td1": "피스풀 플래닛 시그니처(바디/페이셜)",
    "vonestis_table_tr3_td2": "90분",
    "vonestis_table_tr3_td3": "700,000 ~",
    "vonestis_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "vonestis_reserve_title": "예약문의 및 상담",
    "vonestis_reserve_desc1": "064-792-8000, [[EMAIL:bookingSk]]",
    "vonestis_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Program Information",
    "vonestis_title": "VONESTIS Spa",
    "vonestis_subtitle": "the fullness of the five senses that make you forget your daily life for a while at a pleasant travel destination",
    "prev_button": "Previous",
    "vonestis_desc": "Beyond simple skincare, VONESTIS Beauty & Spa aims for more fundamental skin therapy that seeks to restore the ultimate balance of the tired body and mind of everyday life.",
    "vonestis_desc2": "</br>Enjoy the noble intangible value you have built over 30 years, about 280,000 hours, by touching the skin of 120,000 people, and finding your pulse like a relaxing rest. A unique spa space of more than 100 pyeong, consisting of couple suites, couple rooms, and private rooms, gives you the fullness of the five senses that make you forget your daily life for a while at a pleasant destination.",
    "vonestis_program_title": "Programs",
    "vonestis_table_tr1_td1": "Program",
    "vonestis_table_tr1_td2": "Option",
    "vonestis_table_tr1_td3": "Fare(2 people)",
    "vonestis_table_tr2_td1": "Peaceful Planet",
    "vonestis_table_tr2_td2": "60 min.",
    "vonestis_table_tr2_td3": "KRW 500,000 ~",
    "vonestis_table_tr3_td1": "Peaceful Planet Signature (body/face)",
    "vonestis_table_tr3_td2": "90 min.",
    "vonestis_table_tr3_td3": "KRW 700,000 ~",
    "vonestis_table_desc": "※ Special price for P-Leisure users",
    "vonestis_reserve_title": "Reservation",
    "vonestis_reserve_desc1": "064-792-8000, [[EMAIL:bookingSk]]",
    "vonestis_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {
    "breadcrumb": "Program Information",
    "vonestis_title": "본에스티스 스파",
    "vonestis_subtitle": "즐거운 여행지에서 일상을 잠시 잊게 하는 오감의 충만함",
    "prev_button": "이전",
    "vonestis_desc": "본에스티스 뷰티앤스파는 단순한 스킨케어를 넘어 일상의 지친 신체와 정신의 궁극적 균형 회복을 도모하는 보다 근본적인 스킨테라피를 지향합니다.</br>",
    "vonestis_desc2": "30여 년, 약 29만 시간, 12만 명의 피부를 직접 터치하여 결을 읽고, 맥을 찾으며 쌓아온 고귀한 무형의 가치를 편안한 휴식처럼 누리세요. 커플스위트룸, 커플룸, 개인룸으로 구성된 100여 평의 유니크한 스파 공간이 즐거운 여행지에서 일상을 잠시 잊게 하는 오감의 충만함을 당신에게 선사합니다.",
    "vonestis_program_title": "운영 프로그램",
    "vonestis_table_tr1_td1": "프로그램",
    "vonestis_table_tr1_td2": "옵션",
    "vonestis_table_tr1_td3": "요금(2인 기준)",
    "vonestis_table_tr2_td1": "피스풀 플래닛",
    "vonestis_table_tr2_td2": "60분",
    "vonestis_table_tr2_td3": "500,000 ~",
    "vonestis_table_tr3_td1": "피스풀 플래닛 시그니처(바디/페이셜)",
    "vonestis_table_tr3_td2": "90분",
    "vonestis_table_tr3_td3": "700,000 ~",
    "vonestis_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "vonestis_reserve_title": "예약문의 및 상담",
    "vonestis_reserve_desc1": "064-792-8000, [[EMAIL:bookingSk]]",
    "vonestis_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  }
}
</i18n>
